import React from "react";

const mainPage = () => (
  <div className="text-center" style={{ color: "#f44336", marginTop: "20%" }}>
    <i
      className="icon md-alert-circle-o"
      style={{ fontSize: "50px" }}
      aria-hidden="true"
    ></i>
    <p style={{ fontSize: "18px" }}>Could not load data</p>
  </div>
);

export default mainPage;
